import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{attrs:{"no-gutters":"","height":"100%"}},_vm._l((_vm.filtered_navigation_menu),function(menu_item,index){return _c('TheHeaderMenuItem',{key:index,attrs:{"index":index,"current_index":_vm.menu_index,"value":menu_item},on:{"current_index":function($event){_vm.menu_index = $event}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }